import React from 'react';

import { ENUM_QUESTION_TYPE } from 'constants/enum';
import DateOption from 'pages/Survey/Form/_components/question/DateOption';
import FooterQuestion from 'pages/Survey/Form/_components/question/FooterQuestion';
import ImageOption from 'pages/Survey/Form/_components/question/ImageOption';
import ParagraphOption from 'pages/Survey/Form/_components/question/ParagraphOption';
import { DescriptionPreview, ImagePreview, ImagePreviewContainer, TitlePreview } from 'pages/Survey/Form/_components/question/Preview';
import QuestionOption from 'pages/Survey/Form/_components/question/QuestionOption';
import RadioCheckbox from 'pages/Survey/Form/_components/question/RadioCheckbox';
import RecursiOption from 'pages/Survey/Form/_components/question/RecursiOption';
import ShortTextOption from 'pages/Survey/Form/_components/question/ShortTextOption';
import VideoOption from 'pages/Survey/Form/_components/question/VideoOption';
import { DescriptionViewOnly, ImageViewOnly, TitleViewOnly } from 'pages/Survey/Form/_components/question/ViewOnly';
import { checkExistsVideoCategory } from 'utils/helper';

const DragIndicators = require('assets/resources/DragIndicators.svg').default;
const DragIndicatorsActive = require('assets/resources/DragIndicatorsActive.svg').default;

const OptionalForm = (props) => {
  const { form, questionEditing, sectionIndex, questionIndex, data, isPreview, viewOnly, isShowVietName } = props;

  const optionals = {};

  optionals[ENUM_QUESTION_TYPE.DESCRIPTIVE_SHORT_ESSAY] = function () {
    return <ShortTextOption {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.PARAGRAPH] = function () {
    return <ParagraphOption {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.RADIO] = function () {
    if (data.sub_questions && data.sub_questions.length > 0) {
      return <RecursiOption {...props} data={data} OptionalForm={OptionalForm} />;
    }
    return <RadioCheckbox {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.CHECKBOX] = function () {
    if (data.sub_questions && data.sub_questions.length > 0) {
      return <RecursiOption {...props} data={data} OptionalForm={OptionalForm} />;
    }
    return <RadioCheckbox {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.DROPDOWN] = function () {
    return <RadioCheckbox {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.DATE] = function () {
    return <DateOption {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.IMAGES] = function () {
    return <ImageOption {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.VIDEOS] = function () {
    return <VideoOption {...props} data={data} />;
  };

  optionals[ENUM_QUESTION_TYPE.SELECT_QUESTION] = function () {
    return <QuestionOption {...props} data={data} optionals={optionals} />;
  };

  /**
   * Screen App Mobile Review
   */
  if (isPreview) {
    const isVideo = Boolean(data.question_type === ENUM_QUESTION_TYPE.VIDEOS) && checkExistsVideoCategory(data.title);
    return (
      <>
        {!isVideo && <TitlePreview {...props} data={data} />}
        <DescriptionPreview {...props} data={data} />
        <ImagePreview {...props} data={data} />
        {optionals[data.question_type] ? optionals[data.question_type]() : null}
      </>
    );
  }

  if (viewOnly) {
    const isVideo = Boolean(data.question_type === ENUM_QUESTION_TYPE.VIDEOS) && checkExistsVideoCategory(data.title);
    return (
      <div className="pb-2">
        {!isVideo && <TitleViewOnly data={data} isShowVietName={isShowVietName} />}
        <ImageViewOnly data={data} />
        <DescriptionViewOnly data={data} />
        {optionals[data.question_type] ? optionals[data.question_type]() : null}
      </div>
    );
  }

  return (
    <div
      className={`question p-6 pb-4 rounded-lg bg-white-714/50 relative ${questionEditing ? 'select-question' : ''} ${form?.errors?.sections?.[sectionIndex]?.questions?.[questionIndex] && 'border border-solid border-danger-229'}`}
    >
      <img
        className="absolute left-1/2 top-1.75 -translate-x-1/2 cursor-move"
        src={questionEditing ? DragIndicatorsActive : DragIndicators}
        alt="drag indicator"
        width={24}
        height={24}
      />
      {!questionEditing && (
        <>
          <TitleViewOnly {...props} data={data} showTitleNull={true} />
          <DescriptionViewOnly {...props} data={data} />
        </>
      )}
      {!questionEditing && data.images?.[0] && <ImagePreviewContainer {...props} data={data} />}
      {optionals[data.question_type] ? optionals[questionEditing ? ENUM_QUESTION_TYPE.SELECT_QUESTION : data.question_type]() : null}
      {questionEditing && <FooterQuestion {...props} />}
    </div>
  );
};

export default React.memo(OptionalForm);
